import { render, staticRenderFns } from "./DealsBaseView.vue?vue&type=template&id=c79210dc&scoped=true&"
import script from "./DealsBaseView.vue?vue&type=script&lang=js&"
export * from "./DealsBaseView.vue?vue&type=script&lang=js&"
import style0 from "./DealsBaseView.vue?vue&type=style&index=0&id=c79210dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79210dc",
  null
  
)

export default component.exports